import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import {
  CompanyPlanConsumption,
  PlanConsumption,
} from "../pages/customers/plan-consumption/plan-consumption.interface";
import { AuthenticationService } from "app/auth/service";

@Injectable({
  providedIn: "root",
})
export class PlanConsumptionService {
  private url = `${environment.apiUrl}/private/plan-consumptions`;

  constructor(
    private http: HttpClient,
    private readonly authService: AuthenticationService
  ) {}

  // * List plan consumption registries for all subclients
  getPlanConsumptions = (): Observable<CompanyPlanConsumption[]> =>
    this.http.get<CompanyPlanConsumption[]>(`${this.url}/list`);

  // * Get company plan consumption info for the last unended billing period
  getPlanConsumptionByCompanyId = (
    companyId?: string
  ): Observable<PlanConsumption[]> =>
    this.http.get<PlanConsumption[]>(
      `${this.url}/${companyId ?? this.authService.companyId}`
    );
}
